import {
  Component,
  OnInit,
  Inject,
  Injector,
  ViewChild,
  Input,
  EventEmitter,
  Output,
} from "@angular/core";
import { InvoiceCashDeskService } from "../../../services/invoice-cash-desk/invoice-cash-desk.service";
import { ActivatedRoute } from "@angular/router";
import {
  FormGroup,
  FormBuilder,
  Validators,
  ValidatorFn,
  AbstractControl,
} from "@angular/forms";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { MenuService } from "../../../services/menu.service";
import { CashDeskUserOpen } from "../../../model/cash-desk-user-open";
import { InvoiceCashDesk } from "../../../model/invoice-cash-desk";
import { InvoiceCashDeskControlComponent } from "../../controls/invoice-cash-desk/invoice-cash-desk-edit/invoice-cash-desk-edit-control.component";
import { SafeResourceUrl } from "@angular/platform-browser";
import { PdfService } from "../../../services/pdf.service";
import { ResizedEvent } from "angular-resize-event";
import { PatientMailEditDialogComponent } from "../../dialogs/patient-mail-edit-dialog/patient-mail-edit-dialog.component";
import { MatDialog } from "@angular/material";
import { PatientService } from "src/app/services/patient.service";
import { PatientMail } from "src/app/model/patient/patient-mail";

@Component({
  selector: "invoice-cash-desk-view",
  templateUrl: "./invoice-cash-desk-view.component.html",
  styleUrls: ["./invoice-cash-desk-view.component.css"],
})
export class InvoiceCashDeskViewComponent implements OnInit {
  loading: boolean;
  safeResourceUrl: SafeResourceUrl;
  widthExp = 800;
  heightExp = 800;
  @Input() invoiceId: number;
  @Input() appointmentId?: number;
  @Input() atention?: string;
  @Output() onClose = new EventEmitter();

  constructor(
    private invoiceCashDeskService: InvoiceCashDeskService,
    private menuService: MenuService,
    private pdfService: PdfService,
    private patientService: PatientService,
    public dialog: MatDialog,
    private notificationToastService: NotificationToastService,
    private route: ActivatedRoute
  ) {
    this.menuService.setMenuTitle("Cobranza", "Paciente");
  }

  getSafeResourceUrl(): SafeResourceUrl {
    return this.safeResourceUrl;
  }

  close(): void {
    this.onClose.emit();
  }

  async sendMail() {
    try {
      let patientMail: PatientMail = {};

      if (this.appointmentId || this.atention) {
        patientMail = this.appointmentId
          ? await this.patientService.getPatientMailByAppointmentId(
              this.appointmentId
            )
          : await this.patientService.getPatientMailByAtention(this.atention);
      }

      const dialogRef = this.dialog.open(PatientMailEditDialogComponent, {
        width: "50%",
        data: patientMail,
      });

      const result = await dialogRef.afterClosed().toPromise();

      if (result) {
        await this.invoiceCashDeskService.sendMailPatientInvoiceCashDeskPdf(
          this.invoiceId,
          this.appointmentId,
          this.atention,
          result
        );
      }
    } catch (err) {
      console.log(err);
      this.notificationToastService.error(JSON.stringify(err.error), "Factura");
    }
  }

  onResized(event: ResizedEvent): void {
    this.widthExp = event.newWidth;
    this.heightExp = event.newHeight;
  }

  async ngOnInit() {
    this.route.params.subscribe(async (params) => {
      try {
        this.loading = true;
        const paramInvoiceId =
          this.invoiceId && this.invoiceId > 0
            ? this.invoiceId
            : params["InvoiceId"];
        if (paramInvoiceId) {
          const invoiceCashDesk =
            await this.invoiceCashDeskService.getInvoiceCashDeskPdf(
              paramInvoiceId
            );
          const pdfUrl = this.pdfService.base64ToPdfUrl(
            invoiceCashDesk.ReportBase64
          );
          this.safeResourceUrl =
            this.pdfService.pdfUrlToPdfSafeResourceUrl(pdfUrl);
        }
      } catch (err) {
        this.notificationToastService.error(
          JSON.stringify(err.error),
          "Cobranza"
        );
      } finally {
        this.loading = false;
      }
    });
  }
}
